import { z } from 'zod';
import { InitialAssessmentSummaryDataReferredProfessionalSchema } from './InitialAssessmentSummaryDataReferredProfessionalSchema';

// Bug in formik, it does not show formik.errors for arrays
// https://github.com/jaredpalmer/formik/issues/1116
// Validate the list with the schema instead
export const InitialAssessmentSummaryDataReferredProfessionalListSchema =
  z.array(InitialAssessmentSummaryDataReferredProfessionalSchema);
